import type { ContestManageStore } from '../types/store';

import type {
  FieldAction,
  FieldCacheAction,
  SectionAction,
  SectionCacheAction,
  StoreAction,
} from './types/actions';

type OptionsType =
  | {
      entityType: 'fields';
      state: ContestManageStore;
      action: FieldAction;
    }
  | {
      entityType: 'sections';
      state: ContestManageStore;
      action: SectionAction;
    }
  | {
      entityType: 'fieldsCache';
      state: ContestManageStore;
      action: FieldCacheAction;
    }
  | {
      entityType: 'sectionsCache';
      state: ContestManageStore;
      action: SectionCacheAction;
    };

const entityReducer = ({ entityType, state, action }: OptionsType): ContestManageStore => {
  switch (action.operation) {
    case 'SET': {
      return {
        ...state,
        [entityType]: {
          ...state[entityType],
          [action.payload.key]: action.payload.data,
        },
      };
    }
    case 'REMOVE': {
      return {
        ...state,
        [entityType]: {
          ...state[entityType],
          [action.payload.key]: undefined,
        },
      };
    }
    case 'UPDATE': {
      return {
        ...state,
        [entityType]: {
          ...state[entityType],
          [action.payload.key]: {
            ...(state[entityType][action.payload.key] ?? {}),
            ...action.payload.data,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const storeReducer = (
  state: ContestManageStore,
  action: StoreAction
): ContestManageStore => {
  switch (action.type) {
    case 'INIT': {
      return action.payload;
    }
    case 'SET_FIELD':
    case 'REMOVE_FIELD':
    case 'UPDATE_FIELD': {
      return entityReducer({ entityType: 'fields', state, action });
    }
    case 'SET_SECTION':
    case 'REMOVE_SECTION':
    case 'UPDATE_SECTION': {
      return entityReducer({ entityType: 'sections', state, action });
    }
    case 'SET_FIELD_CACHE':
    case 'REMOVE_FIELD_CACHE':
    case 'UPDATE_FIELD_CACHE': {
      return entityReducer({ entityType: 'fieldsCache', state, action });
    }
    case 'SET_SECTION_CACHE':
    case 'REMOVE_SECTION_CACHE':
    case 'UPDATE_SECTION_CACHE': {
      return entityReducer({ entityType: 'sectionsCache', state, action });
    }
    default: {
      return state;
    }
  }
};
